import CommunicationProgramDetailsContainer from './CommunicationProgramDetailsContainer.js';

export default CommunicationProgramDetailsContainer;